module.exports = __webpack_public_path__ + "static/hero-04-b033e528a6c3214c12cce5d4423d7937.jpg";